interface RecentSend {
  id: string;
  type: string;
  status: string;
  total_count: number;
  success_count: number;
  fail_count: number;
  sent_at: string;
}

interface Props {
  sends: RecentSend[];
  loading: boolean;
}

export default function RecentSends({ sends, loading }: Props) {
  const statusIcon = (status: string) => {
    switch (status) {
      case "completed":
        return <i className="ri-checkbox-circle-line text-emerald-400 text-sm"></i>;
      case "failed":
        return <i className="ri-close-circle-line text-red-400 text-sm"></i>;
      case "scheduled":
        return <i className="ri-calendar-schedule-line text-amber-400 text-sm"></i>;
      case "sending":
        return <i className="ri-loader-4-line animate-spin text-sky-400 text-sm"></i>;
      default:
        return <i className="ri-time-line text-gray-400 text-sm"></i>;
    }
  };

  const typeLabel = (type: string) => {
    switch (type) {
      case "sms":
        return "SMS";
      case "lms":
        return "LMS";
      case "mms":
        return "MMS";
      default:
        return type.toUpperCase();
    }
  };

  return (
    <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-white font-semibold text-base">최근 발송</h3>
          <p className="text-gray-500 text-xs mt-0.5">하위 회원 최근 발송 내역</p>
        </div>
        <span className="text-xs text-gray-500">{sends.length}건</span>
      </div>

      <div className="space-y-2.5">
        {loading ? (
          Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 p-3 bg-white/[0.03] rounded-xl border border-white/[0.06]">
              <div className="w-8 h-8 bg-white/[0.06] rounded-lg animate-pulse shrink-0"></div>
              <div className="flex-1 space-y-1.5">
                <div className="w-20 h-3 bg-white/[0.06] rounded animate-pulse"></div>
                <div className="w-32 h-3 bg-white/[0.06] rounded animate-pulse"></div>
              </div>
            </div>
          ))
        ) : sends.length === 0 ? (
          <div className="py-8 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 rounded-full bg-white/[0.04]">
              <i className="ri-send-plane-line text-gray-600 text-xl"></i>
            </div>
            <p className="text-gray-500 text-sm">최근 발송 내역이 없습니다</p>
          </div>
        ) : (
          sends.map((send, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 p-3 bg-white/[0.03] rounded-xl border border-white/[0.06] hover:border-white/[0.1] transition-colors"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/[0.05] shrink-0">
                {statusIcon(send.status)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-white text-sm font-medium whitespace-nowrap">{typeLabel(send.type)}</span>
                  <span className="text-gray-500 text-xs">{send.total_count.toLocaleString()}건</span>
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-emerald-400 text-xs">성공 {send.success_count.toLocaleString()}</span>
                  {send.fail_count > 0 && (
                    <span className="text-red-400 text-xs">실패 {send.fail_count.toLocaleString()}</span>
                  )}
                </div>
              </div>
              <div className="text-right shrink-0">
                <p className="text-gray-500 text-xs whitespace-nowrap">
                  {send.sent_at
                    ? new Date(send.sent_at).toLocaleDateString("ko-KR", { month: "short", day: "numeric" })
                    : "-"}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}